import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';
import { TextField } from '@change/ds-forms';

import { Translate } from '@change-corgi/core/react/i18n';
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { useConfirmVanityUrlFormReskin as useConfirmVanityUrlForm } from 'src/app/pages/starterDashboardV2/shared/hooks';
import { useTrackView } from 'src/app/shared/hooks/tracking';

type Props = {
	petitionSlug: string;
	petitionId: string;
	displayedSignatures: number;
};

export const ConfirmVanityLinkForm: React.FC<Props> = ({ petitionSlug, petitionId, displayedSignatures }) => {
	const {
		data: { urlError, vanityUrl, loading },
		actions: { handleEdit, handleSubmit },
	} = useConfirmVanityUrlForm({ petitionSlug, petitionId, displayedSignatures });
	useTrackView('custom_url_confirm_view', {
		petition_id: `petition_${petitionId}`,
		num_signatures: displayedSignatures,
	});
	return (
		<form data-qa="confirm-vanity-link-form" className="w-full" onSubmit={handleSubmit}>
			<div className="flex flex-col gap-8">
				<div className="flex flex-row items-center gap-2">
					<Text size="medium" className="leading-5">
						Change.org/
					</Text>
					<div className="flex-1">
						<TextField
							type="text"
							label="Custom URL"
							labelIsVisible={false}
							name="vanity-url-input"
							data-testid="vanity-url-input"
							isDisabled
							data-qa="vanity-url-input"
							value={vanityUrl}
							errorMessage={urlError ? urlError.join(', ') : null}
							isInvalid={urlError ? urlError.length > 0 : false}
							size="large"
						/>
					</div>
				</div>
				<div className="flex flex-row justify-end gap-4">
					<Button variant="secondary" size="small" type="button" onClick={handleEdit}>
						<Translate value="corgi.petition.starter_dashboard_v2.grow_petition.copy_link.edit_link" />
					</Button>
					<Button variant="primary" size="small" type="submit" disabled={loading}>
						{loading ? (
							<Loader size={24} className="mx-7" />
						) : (
							<Translate value="corgi.petition.starter_dashboard_v2.grow_petition.copy_link.vanity_link_cta" />
						)}
					</Button>
				</div>
			</div>
		</form>
	);
};
